import type { FunctionComponent } from 'react';
import classnames from 'classnames';
import { Button, ButtonText } from '@andes/button';

import type { ErrorWordings } from '../../../wordings';
import { EmailErrorSVG, ExErrorSVG } from '../../../components/svg/error';
import { handleExecuteNative } from '../../../utils/executeNative';
import { ErrorCodes } from '../../../../services/utils/constants';
import CenterCard from '../../../components/center-card';


type ViewProps = {
  wordings: ErrorWordings;
  isWebview: boolean;
  isMobile: boolean;
  homeUrl: string
  type: string
};

const Error: FunctionComponent<ViewProps> = (props: ViewProps) => {
  const {
    wordings, isWebview, isMobile, homeUrl, type,
  } = props;

  const redirect = () => {
    handleExecuteNative(
      isWebview,
      homeUrl,
      'push',
      {},
    );
  };

  const cardClassName = classnames(
    'error-card',
    { 'error-card--mobile': isMobile && !isWebview },
    { 'error-card--webview': isWebview },
  );

  const containerClassName = classnames(
    'error-card__container',
    type,
  );

  return (
    <CenterCard className={cardClassName}>
      <div className={containerClassName}>
        { type === ErrorCodes.INVITATION_EXPIRED
          ? <EmailErrorSVG />
          : <ExErrorSVG /> }
        <h1 className="error-card__title">{wordings.title}</h1>
        <h2 className="error-card__caption">{wordings.caption}</h2>
        { type === ErrorCodes.FORBIDDEN_REGISTRATION && (
          <>
            <h2 className="error-card__caption">{wordings.captionSecond}</h2>
            <ul className="error-card__unordered_list">
              <li className="error-card__list_item">{wordings.listFirst}</li>
              <li className="error-card__list_item">{wordings.listSecond}</li>
            </ul>
          </>
        )}
      </div>
      { (type === ErrorCodes.FORBIDDEN_REGISTRATION || type === ErrorCodes.INVITATION_EXPIRED) && wordings.action && (
        <Button
          id="error-card-button"
          fullWidth={isMobile}
          className="error-card__action"
          onClick={redirect}
        >
          <ButtonText>{wordings.action}</ButtonText>
        </Button>
      )}
    </CenterCard>
  );
};

export default Error;
